import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://034725db0f4c862356ea6caec8349272@o4509972322516992.ingest.de.sentry.io/4509972324024400",
  sendDefaultPii: true
});